import React, { FC, memo } from 'react';

import Typography from '@mui/material/Typography';

import { FARM_TAG_TITLE, FarmTag } from '@constants/vaults/vault.constants';

import useStyles from './styles.module';

interface Props {
  farmTag: FarmTag;
}

const FarmV3Tag: FC<Props> = ({ farmTag }) => {
  const { classes } = useStyles();

  return (
    <Typography className={classes.tag} variant="caption1">
      {FARM_TAG_TITLE[farmTag]}
    </Typography>
  );
};

export default memo(FarmV3Tag);
